(function() {
  var selectors = {
    player: "#player",
    playbackButton: "#player .playback-controls .playback-button",
    rwButton: "#player .playback-controls .rw-button",
    ffButton: "#player .playback-controls .ff-button",
    playIcon: "#player .playback-controls .playback-button .play",
    pauseIcon: "#player .playback-controls .playback-button .pause",
    timeline: "#timeline",
    timelineProgress: "#timeline .progress",
    timelineHandle: "#timeline .handle",
    currentDuration: "#player .duration .current",
    remainingDuration: "#player .duration .remaining",
    transcriptWord: "#transcript-lines .transcript-word",
    playerLoader: "#player .player-loader",
    speakers: "#transcript-lines .speaker",
  };

  var state = {
    howl: null,
    trackLoaded: false,
    draggingTimelineHandle: false,
    draggingTimelineHandleX: null,
    draggingTimelineHandleMaxX: null,
    currentTranscriptWord: null,
    currentSpeaker: null,
    synced: false,
  };

  $(document).ready(initPlayer);
  $(selectors.playbackButton).click(onClickPlaybackButton);
  $(selectors.ffButton).click(onClickFFButton);
  $(selectors.rwButton).click(onClickRWButton);
  document.addEventListener("scroll", onScroll, true);

  function initPlayer() {
    if (!window.EPISODE || !window.EPISODE.audioUrl) {
      console.error("Episode file not specified");
      return;
    }
    initializeTimeline();
  }

  function onScroll(event) {
    state.synced = false;
  }

  // ---------------------------------
  // Player

  function buildHowlPlayer() {
    $(selectors.player).addClass("loading");
    state.howl = new Howl({
      src: window.EPISODE.audioUrl,
      html5: true, // A live stream can only be played through HTML5 Audio.
      format: ["mp3", "aac"],
      onload: onLoad,
      onpause: onPause,
      onstop: onPause,
      onplay: onPlay,
      onseek: onSeek,
    });
  }

  function onLoad() {
    state.trackLoaded = true;
    $(selectors.player).removeClass("loading");
    $(selectors.player).addClass("loaded");
    $(selectors.currentDuration).text("00:00");
    $(selectors.remainingDuration).text(formatDuration(state.howl.duration()));
  }

  function formatDuration(seconds) {
    var duration = moment.duration(seconds, "seconds");
    var minutes = Math.floor(duration.asMinutes());
    var seconds = duration.seconds();
    return (
      (minutes < 10 ? "0" : "") +
      minutes +
      ":" +
      (seconds < 10 ? "0" : "") +
      seconds
    );
  }

  function onClickPlaybackButton() {
    if (!state.howl) buildHowlPlayer();
    if (window.PLAYING) {
      state.howl.pause();
    } else {
      state.howl.play();
    }
  }

  function onClickFFButton() {
    if (!state.howl) buildHowlPlayer();
    var seek = state.howl.seek();
    if (typeof seek === "number") {
      var duration = state.howl.duration();
      var seekTo = Math.min(seek + 30, duration);
    }
    state.howl.seek(seekTo);
  }

  function onClickRWButton() {
    if (!state.howl) buildHowlPlayer();
    var seek = state.howl.seek();
    var seekTo = Math.max(seek - 15, 0);
    state.howl.seek(seekTo);
  }

  function onPlay() {
    window.PLAYING = true;
    state.synced = true;
    $(selectors.playIcon).removeClass("active");
    $(selectors.pauseIcon).addClass("active");
    requestAnimationFrame(onStep);
  }

  function onPause() {
    window.PLAYING = false;
    state.synced = false;
    $(selectors.playIcon).addClass("active");
    $(selectors.pauseIcon).removeClass("active");
  }

  function onSeek() {
    requestAnimationFrame(onStep);
  }

  function onStep() {
    if (!state.draggingTimelineHandle) {
      var seek = state.howl.seek();
      var duration = state.howl.duration();
      var timeline = document.getElementById("timeline");
      if (typeof seek === "number") {
        $(selectors.currentDuration).text(formatDuration(seek));
        $(selectors.remainingDuration).text(
          formatDuration(state.howl.duration() - seek)
        );
        TweenMax.set(selectors.timelineProgress, {
          scaleX: (seek / duration).toFixed(5),
        });
        TweenMax.set(selectors.timelineHandle, {
          x: ((seek / duration) * timeline.offsetWidth).toFixed(4),
        });
      }
    }
    updateTranscript();
    // If the sound is still playing, continue stepping.
    if (window.PLAYING) {
      requestAnimationFrame(onStep);
    }
  }

  // ---------------------------------
  // Timeline

  function initializeTimeline() {
    initializeTimelineHandle();
  }

  function initializeTimelineHandle() {
    Draggable.create(selectors.timelineHandle, {
      type: "x",
      trigger: selectors.timeline,
      bounds: selectors.timeline,
      onPress: function(e) {
        if (!state.howl) buildHowlPlayer();
        state.draggingTimelineHandle = true;
        var timeline = document.getElementById("timeline");
        TweenMax.set(this.target, {
          x: this.pointerX - timeline.getBoundingClientRect().left,
        });
        state.draggingTimelineHandleX = this.x;
        state.draggingTimelineHandleMaxX = this.maxX;
        this.update();
        var progress = this.x / timeline.offsetWidth;
        TweenMax.set(selectors.timelineProgress, {
          scaleX: progress,
        });
      },
      onDrag: function() {
        if (!state.howl) buildHowlPlayer();
        var timeline = document.getElementById("timeline");
        var progress = this.x / timeline.offsetWidth;
        var duration = state.howl.duration();

        $(selectors.currentDuration).text(formatDuration(progress * duration));
        $(selectors.remainingDuration).text(
          formatDuration((1 - progress) * duration)
        );

        state.draggingTimelineHandleX = this.x;

        TweenMax.set(selectors.timelineProgress, {
          scaleX: progress,
        });
      },
      onRelease: function(e) {
        var timeline = document.getElementById("timeline");
        e.preventDefault();
        if (state.draggingTimelineHandleX) {
          state.howl.seek(
            (state.draggingTimelineHandleX / timeline.offsetWidth) *
              state.howl.duration()
          );
        }
        state.draggingTimelineHandle = false;
        state.draggingTimelineHandleX = null;
        state.draggingTimelineHandleMaxX = null;
      },
    });
  }

  // ---------------------------------
  // Transcript

  function updateTranscript() {
    var seek = state.howl.seek();
    var word = window.EPISODE.transcript.find(function(w) {
      return seek > w.startTime && seek < w.endTime;
    });
    if (word && word !== state.currentTranscriptWord) {
      var $word = $("[data-transcript-word-id='" + word.id + "']");
      $(selectors.transcriptWord).removeClass("active");
      $word.addClass("active");
      state.currentTranscriptWord = word;
      if (state.synced) {
        $("html, body").animate(
          {
            scrollTop: $word.offset().top - window.innerHeight * 0.4,
          },
          500
        );
      }
      if (state.currentSpeaker !== word.speaker) {
        $(selectors.speakers).removeClass("active");
        window.clearBubbles();
        window.animateSpeakerBubbles($word.parent().find(".speaker"));
        $word
          .parent()
          .find(".speaker")
          .addClass("active");
        state.currentSpeaker = word.speaker;
      }
    }
  }
})();
